export default __webpack_public_path__ + "static/media/stingray.cd4e8c95.png";